import {Risorsa} from '../_models/Risorsa';
import {StatoEnum} from '../_models/generated/stato-enum';

/**
 * Feature 155: stati d'ordine che il WriteService scrive sulla macchina di una risorsa.
 * `Risorsa.statiScrittura` è una maschera di bit (bit = `1 << stato`), stesse regole di
 * `StatiScritturaRisorsa` lato backend: `null` vale il default, `0` = la risorsa non scrive ordini.
 */
export const STATI_SCRITTURA_DEFAULT = (1 << StatoEnum.PIANIFICATO) | (1 << StatoEnum.LANCIATO);

/** PAUSA e AVANZAMENTO esclusi: lo scrittore porta l'ordine in PAUSA, verrebbe riscritto a ogni ciclo. */
export const STATI_SCRITTURA_SELEZIONABILI: readonly StatoEnum[] = [
  StatoEnum.DA_PIANIFICARE, StatoEnum.PIANIFICATO, StatoEnum.LANCIATO, StatoEnum.SOSPESO
];

/** Formati il cui scrittore filtra per stato. ZUND scrive con un flusso proprio ed è escluso. */
export const FORMATI_CON_STATI_SCRITTURA: readonly string[] = ['OPCUA', 'FILE', 'MODBUS', 'DB_MSSQL', 'DB_PGSQL'];

export function statiDaMaschera(valore: number | null | undefined): StatoEnum[] {
  const maschera = valore ?? STATI_SCRITTURA_DEFAULT;
  return STATI_SCRITTURA_SELEZIONABILI.filter(stato => (maschera & (1 << stato)) !== 0);
}

export function mascheraDaStati(stati: readonly StatoEnum[] | null | undefined): number {
  return (stati ?? [])
    .filter(stato => STATI_SCRITTURA_SELEZIONABILI.includes(stato))
    .reduce((maschera, stato) => maschera | (1 << stato), 0);
}

export function formatoConStatiScrittura(formato: string | null | undefined): boolean {
  return FORMATI_CON_STATI_SCRITTURA.includes(formato ?? '');
}

/** Stati che il WriteService scrive davvero per la risorsa: per i formati senza filtro (ZUND) quelli di default. */
export function statiScritturaEffettivi(risorsa: Risorsa | null | undefined): StatoEnum[] {
  return statiDaMaschera(formatoConStatiScrittura(risorsa?.formato) ? risorsa?.statiScrittura : null);
}
